function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.408 20.65a3 3 0 111.242-1.242l3.421 3.956-.707.707-3.956-3.421zM16 19a1 1 0 100-2 1 1 0 000 2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 4c0 .46-.103.894-.288 1.283C24.59 6.531 29 11.751 29 18c0 7.18-5.82 13-13 13S3 25.18 3 18C3 11.75 7.41 6.531 13.288 5.283A3 3 0 1119 4zm-3 1a1 1 0 100-2 1 1 0 000 2zM5 18C5 11.925 9.925 7 16 7s11 4.925 11 11-4.925 11-11 11S5 24.075 5 18z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.768 4.354a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l3.535 3.535a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707l-3.535-3.535z",
  fill: "currentColor"
})));